<template>
    <application-modal v-if="visible">
        <div class="amb-modal-header py-1 d-flex justify-content-between">
            <div class="d-flex px-3 align-items-center">
                <h2 class="modal-title mb-0 mr-3">Digital Signature Statement</h2>
            </div>
            <div class="p-3 amb-close-modal" v-on:click="visible = false">
                <i class="fas fa-lg fa-times text-white"></i>
            </div>
        </div>

        <div class="container">
            <div
                class="row pt-0 amb-modal-body"
                style="max-height: 650px; -ms-overflow-y: auto; overflow-y: auto; overflow-x: hidden;"
            >
                <div class="row w-100 mx-1">
                    <div class="col-12 mb-3">
                        <div v-html="statement"></div>
                    </div>
                </div>
            </div>
        </div>
    </application-modal>
</template>

<script>
export default {
    props: {
        statement: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            visible: false
        };
    },
    created() {
        window.addEventListener("openStatement", e => {
            this.visible = true;
        });
    },
    destroyed() {
        window.removeEventListener("openStatement");
    },

    watch: {}
};
</script>
